/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationResourceModel {
    getFixupPrototypeFunction() { return OperationResourceModel.fixupPrototype; }

    static newInstance(model: Partial<OperationResourceModel>): OperationResourceModel {
        let obj = Object.assign(new OperationResourceModel(), model);
        OperationResourceModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationResourceModel>): OperationResourceModel {
        if (!model) return null;
        return OperationResourceModel.newInstance(<OperationResourceModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationResourceModel) {
        if (!obj) return;

        models.OperationResourceModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationResourceModel): boolean {
        Object.setPrototypeOf(obj, OperationResourceModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
    }

    /**
     * resource name
     */
    resource: string;

    /**
     * total count details
     */
    count: number;

}
